<template>
  <PageHeader>
    <template #header-title>
      {{ $t('Bids') }}
    </template>
  </PageHeader>

  <div class="tw-max-h-full">
    <GraphqlDataTable
      :query
      :order-by="initialOrder"
      :filter-black-list="['accounts']"
      :quick-filters="['statuses']"
      :max-height-adjustment="30"
      data-test="freelancer-bids-table"
    >
      <template #no-results>
        {{ $t("You haven't bid on any jobs yet. Once you do, they'll be listed here.") }}
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import PageHeader from '@/components/PageHeader.vue'
import { graphql } from '@/gql'
import { BidOrderByColumn, SortOrder } from '@/gql/graphql'
import { $t } from '@/composables/translation'

const query = graphql(`
  query FreelancerBidsQuery(
    $page: Int!
    $first: Int!
    $accounts: [ID!]
    $statuses: [BidStatus!]
    $clientCompanies: [ID!]
    $orderBy: [BidOrderByClauseInput!]
  ) {
    bids(
      page: $page
      first: $first
      accounts: $accounts
      statuses: $statuses
      companies: $clientCompanies
      orderBy: $orderBy
    ) {
      data {
        job {
          ...JobTitleColumn
          ...JobCompanyColumn
        }

        ...RateColumnBid
        ...BidStatusColumn

        ...BidActionColumn
      }
    }
  }
`) as TypedQueryDocumentNode

const initialOrder = {
  field: BidOrderByColumn.CreatedAt,
  order: SortOrder.Desc,
}
</script>
